//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../no/Builder.js";
let d=[[[0,"SelectedConfigurationName",1,0],[0,"SelectedConfigurationPart",1,"Part",0]],[[["numConnections","ownerParts"],"GetConnectionNames",{R_:{names:""}},0,0],[["ownerParts","names"],"SetConnectionNames",{},2,0],[["connectionName","ownerPart","castMode","remoteIP","remotePort","localIP","localPort","groupIP","rcvBufSize","sendBufSize","updateTime","numSignals","signals"],"GetConnectionInformation",{},2,1],[["connectionName","ownerPart","castMode","remoteIP","remotePort","localIP","localPort","groupIP","rcvBufSize","sendBufSize","updateTime","signals"],"SetConnectionInformation",{},12,1],[["connectionName","ownerPart","castMode","remoteIP","remotePort","localPort","groupIP","eEndian","rcvBufSize","sendBufSize","updateTime","numSignals","signals"],"GetConnectionInformationV2",{},2,0],[["connectionName","ownerPart","castMode","remoteIP","remotePort","localPort","groupIP","eEndian","rcvBufSize","sendBufSize","updateTime","signals"],"SetConnectionInformationV2",{},12,0],[["connectionName","ownerPart","castMode","remoteIP","remotePort","localIP","localPort","groupIP","rcvBufSize","sendBufSize","updateTime","numSignals","signals"],"GetConnectionInformationEx",{},2,1],[["connectionName","ownerPart","castMode","remoteIP","remotePort","localIP","localPort","groupIP","rcvBufSize","sendBufSize","updateTime","signals"],"SetConnectionInformationEx",{},12,1]],[]];
SPLM.Mechatronics.UDPSignalClientBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.UDPSignalClientBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.UDPSignalClientBuilder.Signal = class{
    constructor(name,eIOType,eDataType,offset){
        this.name=name;this.eIOType=eIOType;this.eDataType=eDataType;this.offset=offset;}
    get Name(){return this.name}
    set Name(val){this.name = val}
    get Eiotype(){return this.eIOType}
    set Eiotype(val){this.eIOType = val}
    get Edatatype(){return this.eDataType}
    set Edatatype(val){this.eDataType = val}
    get Offset(){return this.offset}
    set Offset(val){this.offset = val}
};

SPLM.Mechatronics.UDPSignalClientBuilder.SignalEx = class{
    constructor(name,eIOType,strDataType,offset){
        this.name=name;this.eIOType=eIOType;this.strDataType=strDataType;this.offset=offset;}
    get Name(){return this.name}
    set Name(val){this.name = val}
    get Eiotype(){return this.eIOType}
    set Eiotype(val){this.eIOType = val}
    get Strdatatype(){return this.strDataType}
    set Strdatatype(val){this.strDataType = val}
    get Offset(){return this.offset}
    set Offset(val){this.offset = val}
};

export default SPLM;